import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BiRupee } from "react-icons/bi";
import { HiBadgeCheck } from "react-icons/hi";
import { BsBookmarkStarFill, BsStarFill } from "react-icons/bs";
import axios from "axios";
import Rating from "../Rating";
import { ToastContainer } from "react-toastify";
import { SERVER_PATH } from "../../config/env";
import { userInfo } from "../../utils/appInfo";
import { successToaster, errorToaster } from "../../utils/index";
import { getLocalStorage } from "./../../utils/helper";
import { FiCopy, FiShare2 } from "react-icons/fi";
import SocialLinks from "../SocialLinks";
import CustomerReviews from "../Reviews/CustomerReviews";
import MainImg from "../../assets/img/yoga/sivimg2.jpg";
import { formatProductText, formatProductTextJSX } from "../../utils/productTextFormatter";

export default function YogaProducts(props) {
  const isLogin = getLocalStorage("uid") ? true : false;
  let nav = useNavigate();
  const [count, setCount] = useState(1);
  const [ratings, setRatings] = useState(0);
  const [allRating, setAllRating] = useState();
  const [data, setData] = useState([]);
  const param = useParams();
  const [userData, setUserData] = useState(false);

  const getUserId = () => {
    const user = userInfo();
    return user?.email || getLocalStorage("uid") || (userData && userData.email) || "";
  };

  const handleIncrement = () => {
    setCount((prevCount) => prevCount + 1);
  };

  const handleDecrement = () => {
    if (count != 1) setCount((prevCount) => prevCount - 1);
  };

  const toggleState = (clickState) => {
    setRatings(clickState);
  };

  const fetchData = () => {
    axios
      .post(`${SERVER_PATH}get/product.php`, {
        product_id: 69,
      })
      .then((res) => {
        let info = res.data.length ? res.data[0] : {};
        setData(info);
        setCount(1);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const postData = async (e) => {
    if (e) e.preventDefault();
    if (!isLogin) {
      nav(`/profile/${param.productId || 69}`);
      return;
    }

    const userId = getUserId();
    if (!userId) {
      errorToaster({ msg: "Please log in to add products to cart" });
      nav(`/profile/${param.productId || 69}`);
      return;
    }

    let info = {
      product_id: 69,
      user_id: userId,
      quantity: count,
    };

    axios
      .post(`${SERVER_PATH}post/cart.php`, { ...info })
      .then(() => {
        successToaster({ msg: "Added to cart" });
        setCount(1);
      })
      .catch((err) => {
        console.log(err);
        errorToaster({ msg: "Failed to add product to cart." });
      });
  };

  const buyPostData = async (e) => {
    if (e) e.preventDefault();
    if (!isLogin) {
      nav(`/profile/${param.productId || 69}`);
      return;
    }

    const userId = getUserId();
    if (!userId) {
      errorToaster({ msg: "Please log in to buy products" });
      nav(`/profile/${param.productId || 69}`);
      return;
    }

    let info = {
      product_id: 69,
      user_id: userId,
      quantity: count,
    };

    axios
      .post(`${SERVER_PATH}post/cart.php`, { ...info })
      .then((res) => {
        nav(`/cart/${param.productId || 69}`);
      })
      .catch((err) => {
        console.log(err);
        errorToaster({ msg: "Failed to add product to cart." });
      });
  };

  const [selImg, setSelImg] = useState(MainImg)

  const swapFocusImg = (src) => {
    setSelImg(src)
  };

  const overallRating = async () => {
    await axios
      .post(`${SERVER_PATH}get/ratings.php`, {
        product_id: 69,
      })
      .then((res) => {
        setAllRating(res.data);
      });
  };

  // const getUserRating = async () => {
  //   await axios
  //     .post(`${SERVER_PATH}get/ratings.php`, {
  //       user_id: userData.email,
  //       product_id: param.productId,
  //     })
  //     .then((res) => {
  //       setUserRating(res.data.rating);
  //     });
  // };

  const submitRating = async (rate) => {
    axios
      .post(`${SERVER_PATH}post/ratings.php`, {
        user_id: userData.email,
        product_id: 69,
        rating: rate,
      })
      .then((res) => {
        successToaster({ msg: "Rating added successfully" });
        overallRating();
      });
  };

  useEffect(() => {
    setTimeout(() => {
      setUserData(userInfo());
      fetchData();
      overallRating();
      window.scrollTo(0, 0);
    }, 200);
  }, [param.productId]);

  // return <></>
  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    successToaster({ msg: "Copied Successfully" });
  };

  const handleShareProduct = () => {
    if (navigator.share) {
      navigator.share({
        title: data.product_name || "Ultimate Health Challenge",
        text: `Check out ${data.product_name || "Ultimate Health Challenge"} on Sivam Farms!`,
        url: window.location.href,
      }).catch(() => {});
    } else {
      handleCopyLink();
    }
  };

  return (
    <>
      <section className="productPage" key={data.product_id || 69}>
        <div className="container pb-5">
          <div className="row">
            <div className="col-lg-5 mt-5">
              <div className="card mb-3">
                <img
                  className="card-img img-fluid productDetailImg"
                  src={selImg}
                  alt="sivamfarms products"
                  id="product-detail"
                />
              </div>
            </div>
            <div className="col-lg-7 mt-5">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                    <h1 className="h5 text-uppercase productDetailTitle mb-0">
                      {data.product_name || "Ultimate Health Challenge"}
                    </h1>
                    <div className="d-flex gap-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary rounded-pill d-inline-flex align-items-center gap-1"
                        onClick={handleCopyLink}
                        title="Copy Product Link"
                      >
                        <FiCopy /> <small className="d-none d-sm-inline">Copy Link</small>
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-success rounded-pill d-inline-flex align-items-center gap-1"
                        onClick={handleShareProduct}
                        title="Share Product"
                      >
                        <FiShare2 /> <small className="d-none d-sm-inline">Share</small>
                      </button>
                    </div>
                  </div>
                  <p>
                    <span
                      className="list-inline-item text-dark fw-700"
                      style={{ fontSize: "1.4em" }}>
                      <BiRupee style={{ marginTop: "-3px" }} />
                      {data.offer_price || 999}
                    </span>
                  </p>
                  <form onSubmit={(e) => e.preventDefault()}>
                    <div className="row pb-3">
                      <div className="col d-grid">
                        <button
                          onClick={buyPostData}
                          type="button"
                          className="btn btn-success btn-sm py-2 text-uppercase"
                          name="submit"
                          value="buy"
                          style={{
                            borderRadius: "0",
                            letterSpacing: ".2px",
                            fontWeight: "500",
                          }}>
                          Buy Now
                        </button>
                      </div>
                      <div className="col d-grid">
                        <button
                          onClick={postData}
                          type="button"
                          className="btn btn-warning btn-sm py-2 text-uppercase"
                          name="submit"
                          value="addtocard"
                          style={{
                            borderRadius: "0",
                            letterSpacing: ".2px",
                            fontWeight: "500",
                          }}>
                          Add To Cart
                        </button>
                      </div>
                    </div>
                  </form>
                  <h6
                    className="text-uppercase mt-3"
                    style={{ color: "#757575" }}>
                    Description:
                  </h6>
                  {data.description ? (
                    <div className="health-program">
                      {data.title1 && <h4>▶ {formatProductText(data.title1)}</h4>}
                      <div className="mb-3">
                        {formatProductTextJSX(data.description)}
                      </div>
                      {data.benefits && (
                        <>
                          <h3>👉🏻 Benefits you will gain</h3>
                          <div className="mb-3">
                            {formatProductTextJSX(data.benefits)}
                          </div>
                        </>
                      )}
                      {data.instructions && (
                        <div className="mb-3">
                          {formatProductTextJSX(data.instructions, "▶ ")}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="health-program">
                      <h4>▶ Presenting ULTIMATE HEALTH CHALLENGE - SATHYA HEALTH and WELLNESS</h4>
                      <ul>
                          <li>✅ 15 days of traditional healthy recipes</li>
                          <li>✅ Powerful lifestyle habits</li>
                          <li>✅ Physical activity, Pranayama and meditation</li>
                          <li>✅ Yogic Detox</li>
                          <li>✅ Women health care</li>
                      </ul>
                      <h3>👉🏻 Benefits you will gain</h3>
                      <ul>
                          <li>✅ Reach your health goal</li>
                          <li>✅ Gain full control of your cravings</li>
                          <li>✅ Gain much more energy</li>
                          <li>✅ Experience mental clarity</li>
                          <li>✅ Get deeper sleep</li>
                      </ul>
                      <p><strong>▶ WhatsApp:</strong> <a href="https://wa.me/919444800697" target="_blank" rel="noopener noreferrer">9444800697</a> for further queries.</p>
                    </div>
                  )}
                  <SocialLinks product={data} />
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12">
              <CustomerReviews productId={data.product_id || param.productId || 69} />
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}
